export const multiPlatformFiltersInitialState = {
  platformFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [
      'news',
      'instagram',
      'instagramComment',
      'twitter',
      'virasty',
      'telegram',
      'newspaper',
      'nativePlatforms',
      'linkedin',
    ],
    componentName: 'platformFilter',
    translateKey: 'filter:platform',
  },
  hashtagCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'hashtagCloudFilter',
    translateKey: 'filter:hashtagCloud',
  },
  seenStatusFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'both',
    componentName: 'seenStatusFilter',
    translateKey: 'filter:seenStatus',
  },
  contentTagFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'contentTagFilter',
    translateKey: 'filter:contentsTag',
  },
  languageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
  },
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    platform: 'multiPlatform',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    selectedValue: '',
    filterType: 'include',
    hasIncludeExclude: true,
  },
};
